import { render, staticRenderFns } from "./AddId.vue?vue&type=template&id=4bf064f1&scoped=true"
import script from "./AddId.vue?vue&type=script&lang=js"
export * from "./AddId.vue?vue&type=script&lang=js"
import style0 from "./AddId.vue?vue&type=style&index=0&id=4bf064f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf064f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
